import React, {useEffect,useState, useRef} from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import {FormValidator, useFormValidator, Inputs, Scrollable, Message } from 'coaz-ui';
import TariffCriteria from './TariffCriteria';
import client from '../client'

const EditTariff = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [tariffable,setTariffable] = useState(null);
    const [criteria,setCriteria] = useState(null);
    const [tariff,setTariff] = useState(null);
    const [message,setMessage] = useState({content:'',success:false});
    const [durationUnits,setDurationUnits] = useState([]);
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const {request,errorMessage,getByReference} = client;
 
    const submit = async (e) => {
        if(tariff && tariff.durationUnit) {
            try {
                const response = await request('PUT','tariffs',tariff);

                if (response && response.tariffableReference && response.criteriaValue) {
                    return {
                        message: 'Successful',
                        success: true
                    };
                }

                return {
                    message: errorMessage(response)
                };
            } catch (error) {
                return {
                    message: errorMessage(error)
                };
            }
        }
    };

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);

    const inputs = [
        {
            label:'Tariffable',
            type:'text', 
            name:'tariffable',
            disabled:true,
            value:tariffable && tariffable.name?tariffable.name:'',   
            placeholder:'Enter name...'
        },
        {
            label:'Criteria Value',
            type:'text', 
            name:'criteriaValue',
            disabled:true,
            value:criteria && criteria.name?criteria.name:criteria?criteria:'',   
            placeholder:'Enter name...'
        },
        {
            label:'Price',
            type:'number', 
            name:'price',
            value:tariff && tariff.price?tariff.price:0,   
            placeholder:'Enter price...',
            onChange:(e) => {handleChange(e,(e) => {
                let value = e.target.value;
                if(isNaN(value)) {
                    return;
                }
                setTariff({...tariff,price: value});
            })},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Duration Unit',
            type:'select',
            options:() => {
                let options = [];
                durationUnits.map((option,i) => options.push(<option key={i}>{option.unit}</option>));
                return options;
            },
            name:'durationUnit', 
            value:tariff && tariff.durationUnit?tariff.durationUnit.unit:'',
            onChange:(e) => handleChange(e,(e) => {
                let value = durationUnits.find(unit => {return unit.unit == e.target.value}); 
                setTariff({...tariff,durationUnit:value});
            })
        },
        {
            label:'Duration',
            type:'number', 
            name:'duration',
            value:tariff && tariff.duration?tariff.duration:'',   
            placeholder:'Enter duration...',
            onChange:(e) => {handleChange(e,(e) => {
                let value = e.target.value;
                if(isNaN(value)) {
                    return;
                }
                setTariff({...tariff,duration: value});
            })},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Default',
            type:'checkbox',
            name:'default',
            value:tariff && tariff.default,   
            onChange:(e) => {
                setTariff({...tariff,default: !tariff.default});
            }
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        if(!params || !params.tariffableReference || !params.criteriaValue) return;
        (async () => { 
            let tarif = null;
            await request('GET','tariffs/by-id',null,{tariffableReference:params.tariffableReference,criteriaValue:params.criteriaValue})
            .then((response) => {
                if(response && response.tariffableReference && response.criteriaValue) {
                    tarif = response;
                } 
            })
            .catch((error) => {
                console.log(error);
            })

            if(tarif) {
                await getByReference(params.tariffableReference)
                .then((response) => {
                    if(response && response.ref) {
                        setTariffable(response);
                    } 
                })
                .catch((error) => {
                    console.log(error);
                })

                await getByReference(params.criteriaValue)
                .then((response) => {
                    if(response && response.ref) {
                        setCriteria(response)
                    } 
                })
                .catch((error) => {
                    setCriteria(params.criteriaValue);
                })

                await request('GET',`durationunits`)
                .then((response) => {
                    if(response && response.length > 0) {
                        setDurationUnits(response);
                    } else {
                        setDurationUnits([]);
                    }
                })
                .catch((error) => {
                    setDurationUnits([]);
                })
            }
            setTariff(tarif);
        })()
    },[])

    return (
        <FormValidator>
            <div className='flex flex-col w-full h-auto'>
                <div className='flex flex-col w-full h-auto space-y-4 shrink-0'>
                    <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                </div>
            </div>
        </FormValidator>
      )
}

export default EditTariff